import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className='Footer-container footer-container'>
      <div className='container'>
        <a href='https://www.jacobruiz.design/' className='tagline'>
          Made on Earth.
        </a>
        <Link className='link' to="/releases">Releases</Link>
        <Link className='link' to="/help">Help</Link>
        <span className='twitter'>
          👋Say hi!
          {/* */}{' '}
          <a href='https://twitter.com/JacobRuizDesign'>@JacobRuizDesign</a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
